/**
 * React Context definitions for all application state stores.
 * Provides dependency injection for signal-based state management to enable testability.
 */

import type { ReactNode } from 'react';

import type { $AppContainer } from './AppContainer.js';

import { createState } from '@elara/client-core/lib/signals-utils';

import { AppContext } from './AppContext.js';

export const AppState = createState(() => {});

export interface StateProviderProps {
  app: $AppContainer;
  /** Child components */
  children: ReactNode;
}

/**
 * Root state provider that supplies all state stores via React Context.
 * In production, uses the real singleton state stores.
 * In tests, allows injection of mock state stores.
 */
export function StateProvider({ app, children }: StateProviderProps) {
  return <AppContext value={app}>{children}</AppContext>;
}
